// 客服工作台专用 HTTP 实例：与 admin 模块的 token 隔离，
// 避免客服登录态与管理后台登录态互相覆盖。
// 登录仍复用既有的后台登录接口 /yljx/admin/auth/login（管理员账号）。
import axios from 'axios'

const TOKEN_KEY = 'cs_jwt'
const PROFILE_KEY = 'cs_profile'

/** 管理后台的 token 键：客服页面现在也会内嵌在 /admin/* 里，需要按当前所在的壳取 token */
const ADMIN_TOKEN_KEY = 'admin_jwt'

export function getToken () {
  // 两套壳共用同一套后台接口与账号体系（登录接口相同），token 来源跟随「当前所在的壳」：
  //   /admin/*（后台管理，含内嵌的「客服管理」页面）→ admin_jwt
  //   /cs/*（独立客服工作台）→ cs_jwt
  // 取不到再退回另一个：这样后台里不需要客服再登录一次，客服工作台里也不会因为
  // 缺 cs_jwt 就直接 401（历史上两处登录态本就同源，只是键名不同）。
  const inAdminShell = typeof window !== 'undefined' && window.location.pathname.indexOf('/admin') === 0
  const primaryKey = inAdminShell ? ADMIN_TOKEN_KEY : TOKEN_KEY
  const fallbackKey = inAdminShell ? TOKEN_KEY : ADMIN_TOKEN_KEY
  return localStorage.getItem(primaryKey) || localStorage.getItem(fallbackKey) || ''
}

export function setToken (token) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuth () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(PROFILE_KEY)
}

export function getProfile () {
  const raw = localStorage.getItem(PROFILE_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setProfile (profile) {
  if (profile) localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
}

const service = axios.create({
  baseURL: '/',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const body = response.data
    // 后端 ApiResp 约定：成功 code="1111"（字符串），失败 code="0000"。
    if (body && typeof body.code !== 'undefined') {
      if (body.code === '1111') {
        return body.data
      }
      const err = new Error(body.msg || '请求失败')
      err.code = body.code
      throw err
    }
    return body
  },
  error => {
    let message = '网络错误'
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        clearAuth()
        message = '登录已失效，请重新登录'
      } else if (status === 403) {
        message = '无权限访问'
      } else if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else {
        message = `请求失败 (${status})`
      }
    } else if (error.code !== undefined) {
      message = error.message
    }
    error.uiMessage = message
    return Promise.reject(error)
  }
)

export default service
